import { render, staticRenderFns } from "./ScanBarcodeFBMAdmin.vue?vue&type=template&id=71b55956&scoped=true"
import script from "./ScanBarcodeFBMAdmin.vue?vue&type=script&lang=js"
export * from "./ScanBarcodeFBMAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b55956",
  null
  
)

export default component.exports